import { makeObservable, observable, flow, action } from "mobx";
import { api } from "@/lib/services";

import RemoveSubscriberSchema from "@/areas/subscriptions/schemas/RemoveSubscriberSchema";
import {
  beginSubscriberToast,
  completeSubscriberToast,
  failSubscriberToast,
} from "@/areas/subscriptions/components/subscribers/subscriberToast";

export default class RemoveSubscriberStore {
  visible = false;
  processing = false;
  subscriber = null;

  constructor(parentStore, apiPrefix) {
    makeObservable(this, {
      visible: observable,
      processing: observable,
      subscriber: observable,
      show: action,
      hide: action,
      toggle: action,
      save: flow,
    });

    this.parentStore = parentStore;
    this.apiPrefix = apiPrefix;
  }

  show(subscriber) {
    this.visible = true;
    this.subscriber = subscriber;
  }

  hide() {
    this.visible = false;
    this.subscriber = null;
  }

  toggle(visible) {
    this.visible = visible === true ? true : visible === false ? false : !this.visible;
    if (!this.visible) {
      this.subscriber = null;
    }
  }

  *save(data, options) {
    let toastId;
    const removedRoles = this.subscriber?.subscriptions ?? [];
    try {
      this.processing = true;
      const parseResult = RemoveSubscriberSchema.safeParse(data);
      if (!parseResult.success) {
        return parseResult;
      }

      toastId = beginSubscriberToast({
        user: data.user,
        roles: removedRoles,
        message: "Removing from",
      });

      const response = yield api.post(`${this.apiPrefix}/subscribers`, data);
      this.visible = false;

      completeSubscriberToast({
        toastId,
        user: data.user,
        roles: removedRoles,
        message: "Removed from",
      });

      this.parentStore.browseSubscribersStore.load({ search: "", page: 1 });
      return { success: true, data: response.data };
    } catch (e) {
      failSubscriberToast({
        toastId,
        message: "Error while removing subscriber",
        description: e.message,
      });
      return { success: false, error: e };
    } finally {
      this.processing = false;
    }
  }
}
